// @flow
import * as React from 'react';

import styles from './ProductDetailsGrid.module.scss';;


type Props = {
  children: React.Node,
}

const ProductDetailsGrid = ({ children }: Props) => (
  <div className={styles.root}>
    {children}
  </div>
);

export default ProductDetailsGrid;
